module.exports = __webpack_public_path__ + "static/media/Rollos.0123717c.jpg";